import React, { useRef, useState, useCallback, useEffect, useContext } from 'react';

import FormSectionLayout from '../../layouts/FormSectionLayout';
import HeadingText from '../../common/HeadingText/HeadingText';
import TextField from '../../common/TextField/TextField';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { Container, Form, Row, Col, Spinner } from 'reactstrap';
import './AddUpdatePromosCityLevelPage.scss';
import ButtonComponent from '../../common/Button/ButtonComponent';

import {
	IAddUpdatePromoCityLevelPageProps,
	ICreatePromoPayload,
	IValidationObject,
	IPromoProductSearchNormalized,
	IVolumetricPromoDetailResponseNormalized,
	IVolumetricPromoSlabs,
	IAddUpdateBasketPromoState,
	IBasketPromoDetailResponseNormalized,
	IIdValuePairResponse,
	IAddUpdateDynamicPromoState,
	IAddUpdateVolumetricPromoState,
	IZonesResponseObject,
	IDynamicPromoDetailResponseNormalized,
	IAddUpdateUserLevelPromoState,
	IUserLevelPromoDetailResponseNormalized,
	ISelectDropdownOption,
} from '../../../interfaces/Index';
import LoaderComponent from '../../common/Loader/Loader';
import { _ } from '../../../utils/lib';
import {
	checkPromoValidations,
	decimalOnlyValidator,
	positiveNegativeNumberValidator,
} from '../../../utils/Validators';

import {
	normalizeBulkUploadPayload,
	normalizeProductCommandoCategories,
	normalizePromoProductSearchResult,
} from '../../../normalizer/GlobalProductNormalizer';
import {
	promoBasketProductBodyDataAndKeyTypes,
	promoProductBodyDataAndKeyTypes,
	promoProductFooterData,
} from './PromosCityLevelTableConstants';
import { AbilityContext } from '../../../config/Can';
import Switch from '../../common/Switch/Switch';
import Checkbox from '../../common/Checkbox/Checkbox';
import DataTablePromoProductSearch from '../../common/DataTablePromoProductSearch/DataTablePromoProductSearch';
import Modal from '../../common/Modal/Modal';
import {
	generateDynamicPromoUpdateMeta,
	normalizeCreateBasketPromoPayload,
	normalizedDynamicCreatePromoPayload,
	normalizedUserLevelCreatePromoPayload,
	normalizedVolumetricCreatePromoPayload,
} from '../../../normalizer/PromoNormalizer';
import Tabs from '../../common/Tabs/Tabs';
import {
	IS_AGREEMENT_CHECK,
	PROMO_STATUS,
	PROMO_TYPE,
	ULP_DYNAMIC_LEVEL,
	CHANNEL_OPTIONS,
	PROMO_OPTIONS,
	PROMO_BASKET_DISCOUNT_OPTIONS,
	UC,
	WAREHOUSE,
	NEW_PROMO,
	UPDATE_A_PROMO,
	ADD_A_PROMO,
	CHANNEL,
	TYPE_PROMO,
	BASKET_CATEGORIES,
	DISCOUNT_PER_UNIT,
	DYNAMIC_PROMO_CRITERIA_TYPE,
	PROMO_TYPE_CONST,
} from './constants/PromosCityLevelConstants';
import { SelectDropDown } from '../../common/SelectDropDown/SelectDropDown';
import SearchableSelect from 'components/common/SearchableSelect/SearchableSelect';
import MultiSelectDropDown from 'components/common/MultiSelectDropDown/MultiSelectDropDown';
import {
	acceptableFormats,
	ACTIVE,
	CHANNEL_CUSTOMER_APP,
	CHANNEL_AGENT_APP,
	CHANNEL_TELESALES,
	INACTIVE,
	CATEGORY_SIZE,
	UC_TYPE,
	UPLOAD_CSV,
	STATUS,
} from 'config/constants';
import UploadButtonComponent from '../../common/UploadButton/UploadButtonComponent';
import {
	closeUserLevelModal,
	mapSlabsFromDiscount,
	searchAndSetProductPrice,
	setCreatedAndUpdateUser,
	validateBasketPromo,
	validateDynamicPromo,
	validateUserLevelPromo,
	validateSlabs,
} from './helpers/AddUpdatePromosCityLevelPage.helper';
import { doProductAPIsearch } from './helpers/AddUpdatePromosCityLevelPage.helper';

import uploadSvg from 'assets/images/uploading.svg';
import backArrow from 'assets/images/back_arrow.svg';
import searchIcon from 'assets/images/search-icon.svg';
import close from 'assets/images/close.svg';
import error from 'assets/images/error.svg';
import warning from 'assets/images/warning.svg';
import { IUpdatePromoPayload } from 'interfaces/userLevelPromo.interface';

const AddUpdatePromosPage: React.FunctionComponent<IAddUpdatePromoCityLevelPageProps> = props => {
	let selectedProducts: any = useRef(props.dummyProductDataProp || []);
	let selectedProductIndex: any = useRef([]);

	const {
		fetchPromoDetails,
		isEdit,
		promo,
		getCommandoCategories,
		fetchCustomerConfig,
		getPromoByType,
	} = props;

	const ability = useContext(AbilityContext);

	const [volumetricPromoState, setVolumetricPromoState] = useState<IAddUpdateVolumetricPromoState>({
		id: props.promo ? props.promo.id || '' : '',
		promoDescription: props.promo ? props.promoDescription : '',
		channel: props.promo ? props.promo.channel || CHANNEL_CUSTOMER_APP : CHANNEL_CUSTOMER_APP,
		customerChannels: props.promo ? props.promo.customerChannels : [],
		productId: props.promo ? props.promo.productId || '' : '',
		productVariantId: props.promo ? props.promo.id || '' : '',
		productSku: props.promo ? props.promo.sku || '' : '',
		productTitle: props.promo ? props.promo.productTitle || '' : '',
		promoStatus: props.promo ? (props.promo.promoStatus === ACTIVE ? true : false) : true,
		productActualPrice: props.dummyActualPrice || '-',
		selectedCity: props.selectedCity && props.selectedCity,
		slabs: [
			{
				minUnits: props.dummyMinUnits || '',
				discountPerUnit: props.dummyDiscount || '',
				discountedUnitPrice: '-',
				isAgreementCheck: props.dummyAgreement || false,
			},
			{
				minUnits: props.dummyMinUnits || '',
				discountPerUnit: props.dummyDiscount || '',
				discountedUnitPrice: '-',
				isAgreementCheck: props.dummyAgreement || false,
			},
		],
	});

	//Lazy initialization of dynamicPromoState that helps in less expensive performance operation
	//getInitialState() function is re-rendered on just initial state
	const [dynamicPromoState, setDynamicPromoState] = useState<IAddUpdateDynamicPromoState>(
		function getInitialState() {
			const dynamicPromoState = {
				id: props.promo ? props.promo.id || '' : '',
				promoDescription: props.promo ? props.promoDescription : '',
				channel: props.promo ? props.promo.channel || CHANNEL_CUSTOMER_APP : CHANNEL_CUSTOMER_APP,
				customerChannels: props.promo ? props.promo.customerChannels : [],
				productId: props.promo ? props.promo.productId || '' : '',
				productVariantId: props.promo ? props.promo.id || '' : '',
				productSku: props.promo ? props.promo.sku || '' : '',
				productTitle: props.promo ? props.promo.productTitle || '' : '',
				promoStatus: props.promo ? (props.promo.promoStatus === ACTIVE ? true : false) : true,
				productActualPrice: props.dummyActualPrice || '-',
				selectedCity: props.selectedCity && props.selectedCity,
				dynamicPromoCriteriaType: props.dynamicPromoCriteriaType
					? props.dynamicPromoCriteriaType === WAREHOUSE
						? WAREHOUSE
						: UC
					: '',
				includedUcs: props.ucList ? props.ucList : [],
				includedWarehouses: props.warehouseList ? props.warehouseList : [],
				isDynamicTypeFetched: props.dynamicPromoCriteriaType !== '' ? true : false,
				minUnits: props.dummyMinUnits || '',
				discountPerUnit: props.dummyDiscount || '',
				discountedUnitPrice: '-',
				isAgreementCheck: props.isEdit
					? true
					: props.promo && props.promo.isAgreementCheck
					? true
					: false,
			};
			return dynamicPromoState;
		}
	);

	const [basketPromoState, setBasketPromoState] = useState<IAddUpdateBasketPromoState>({
		id: props.promo ? props.promo.id || '' : '',
		promoDescription: props.promo ? props.promoDescription : '',
		channel: props.promo ? props.promo.channel || '' : '',
		customerChannels: props.promo ? props.promo.customerChannels : [],
		basketProducts:
			props.promo && props.promo.basketProducts
				? props.promo.basketProducts || []
				: props.dummyBasketProductsProp || [],
		minOrderValue: props.promo ? props.promo.minOrderValue || '' : '',
		discountType: '0',
		discountValue: props.promo ? props.promo.discountValue || '' : '',
		isAgreementCheck: props.isEdit
			? true
			: props.promo && props.promo.isAgreementCheck
			? true
			: false,
		promoStatus: props.promo ? (props.promo.promoStatus === ACTIVE ? true : false) : true,
		basketCategories: '-1',
	});

	const [userLevelPromoState, setUserLevelPromoState] = useState<IAddUpdateUserLevelPromoState>({
		id: props.promo ? props.promo.id || '' : '',
		promoDescription: props.promo ? props.promoDescription : '',
		channel: props.promo ? props.promo.channel || CHANNEL_CUSTOMER_APP : CHANNEL_CUSTOMER_APP,
		customerChannels: props.promo ? props.promo.customerChannels : [],
		productId: props.promo ? props.promo.productId || '' : '',
		productVariantId: props.promo ? props.promo.id || '' : '',
		productSku: props.promo ? props.promo.sku || '' : '',
		productTitle: props.promo ? props.promo.productTitle || '' : '',
		promoStatus: props.promo ? (props.promo.promoStatus === ACTIVE ? true : false) : true,
		productActualPrice: props.dummyActualPrice || '-',
		selectedCity: props.selectedCity && props.selectedCity,
		discountPerUnit: props.dummyDiscount || '',
		discountedUnitPrice: '-',
		userLevelCsvFile: null,
		userLevelCsvFileName: '',
		isUserLevelPromoCsvUploaded: false,
		isUserLevelPromoCsvError: props.promo ? props.promo.isUserLevelPromoCsvError : false,
		userLevelPromoCsvError: props.promo ? props.promo.userLevelPromoCsvError : '',
		isAgreementCheck: props.isEdit
			? true
			: props.promo && props.promo.isAgreementCheck
			? true
			: false,
		promoId: props.promoId ? props.promoId : '',
	});

	const [isSearch, setIsSearching] = useState(props.dummyIsSearch || false);
	const [searchTerm, setSearchTerm] = useState('');
	const [showModal, setIsShowModal] = useState(false);
	const [notificationModal, setNotificationModal] = useState(false);

	const [productData, setProductData] = useState<Array<IPromoProductSearchNormalized>>(
		props.dummyProductDataProp || []
	);
	const [isProductLoading, setProductLoading] = useState(false);

	const [createdByUser, setCreatedByUser] = useState('');
	const [updatedByUser, setUpdatedByUser] = useState('');
	const [promoType, setPromoType] = useState('0');

	const [commandoCategoryState, setCommandoCategories] = useState(props.commandoProductCategories);

	const [ucs, setUcList] = useState<IZonesResponseObject[]>(props.ucList || []);
	const [warehouses, setWarehouseList] = useState<IZonesResponseObject[]>(props.warehouseList || []);

	const [userLevelCsvFileName, setUserLevelCSVFilename] = useState('');

	const [showUserLevelModal, setIsShowUserLevelModal] = useState(false);

	useEffect(() => {
		if (promoType !== PROMO_TYPE_CONST.VOLUMETRIC && props.customerConfig.customerChannels) {
			handleCustomerChannelChange(props.customerConfig.customerChannels.slice());
		} else {
			handleCustomerChannelChange([]);
		}
	}, [promoType]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (isEdit && promo && promo.id) {
			fetchPromoDetails(promo.id);
		}
		getCommandoCategories(true, {
			size: CATEGORY_SIZE,
		});
		fetchCustomerConfig();
	}, []);

	useEffect(() => {
		if (!isEdit) {
			getPromoByType(volumetricPromoState.selectedCity.id, PROMO_TYPE.BASKET);
		}
	}, []);

	useEffect(() => {
		if (props.isPromoDetailsFetched && props.promoDetails) {
			const setProductPrice = async () => {
				const productPrice = await searchAndSetProductPrice(props.promo.productId);
				if (props.promoDetails.type === PROMO_TYPE.VOLUMETRIC) {
					setVolumetricPromoState({
						...volumetricPromoState,
						slabs: mapSlabsFromDiscount(
							(props.promoDetails as IVolumetricPromoDetailResponseNormalized).slabs,
							productPrice,
							volumetricPromoState
						),
						productActualPrice: productPrice,
						channel: (props.promoDetails as IVolumetricPromoDetailResponseNormalized).channel,
						customerChannels: props.promoDetails.customerChannels,
					});
					setCreatedAndUpdateUser(
						props.promoDetails as IVolumetricPromoDetailResponseNormalized,
						setCreatedByUser,
						setUpdatedByUser
					);
				} else if (props.promoDetails.type === PROMO_TYPE.DYNAMIC) {
					setDynamicPromoState({
						...dynamicPromoState,
						productActualPrice: productPrice,
						channel: (props.promoDetails as IDynamicPromoDetailResponseNormalized).channel,
						customerChannels: props.promoDetails.customerChannels,
					});
				} else if (props.promoDetails.type === PROMO_TYPE.ULP) {
					setUserLevelPromoState({
						...userLevelPromoState,
						productActualPrice: productPrice,
						channel: (props.promoDetails as IUserLevelPromoDetailResponseNormalized).channel,
						customerChannels: props.promoDetails.customerChannels,
						discountPerUnit: props.promoDetails.discountPerUnit.discount,
					});
				}
				setCreatedAndUpdateUser(
					props.promoDetails as IDynamicPromoDetailResponseNormalized,
					setCreatedByUser,
					setUpdatedByUser
				);
			};
			if (props.promoDetails.type === PROMO_TYPE.VOLUMETRIC) {
				setProductPrice();
			} else if (props.promoDetails.type === PROMO_TYPE.BASKET) {
				setBasketPromoState({
					...basketPromoState,
					discountValue: (
						props.promoDetails as IBasketPromoDetailResponseNormalized
					).discountValue.toString(),
					minOrderValue: (
						props.promoDetails as IBasketPromoDetailResponseNormalized
					).minOrderValue.toString(),
					basketProducts: (
						props.promoDetails as IBasketPromoDetailResponseNormalized
					).basketProducts.slice(),
					promoStatus: props.promoDetails.promoStatus === ACTIVE,
					id: props.promoDetails.id,
					channel: (props.promoDetails as IBasketPromoDetailResponseNormalized).channel,
					customerChannels: props.promoDetails.customerChannels,
					basketCategories:
						(props.promoDetails as IBasketPromoDetailResponseNormalized).basketCategories &&
						(props.promoDetails as IBasketPromoDetailResponseNormalized).basketCategories.length > 0
							? (props.promoDetails as IBasketPromoDetailResponseNormalized).basketCategories[0]
									.categoryId || ''
							: '',
				});
				setPromoType('1');
			} else if (props.promoDetails.type === PROMO_TYPE.DYNAMIC) {
				setProductPrice();
				setPromoType('2');
			} else if (props.promoDetails.type === PROMO_TYPE.ULP) {
				setProductPrice();
				setPromoType('3');
			}
		}
	}, [props.isPromoDetailsFetched]);

	useEffect(() => {
		const { error, isError, isPromoByTypeFetchError, isFetchCategoryError, commandoCategoryError } =
			props;
		if (isError || isPromoByTypeFetchError) {
			alert((error! as any).errors);
		}
		if (isFetchCategoryError) {
			alert((commandoCategoryError! as any).errors);
		}
	}, [props.isError, props.isFetchCategoryError]);

	useEffect(() => {
		const { isPromoAdded, backButtonHandler, isPromoUpdated, clearPromoDetails } = props;
		if (isPromoAdded || isPromoUpdated) {
			clearPromoDetails();
			backButtonHandler(true, volumetricPromoState.selectedCity);
		}
	}, [props.isPromoAdded, props.isPromoUpdated]);

	useEffect(() => {
		const { commandoProductCategories } = props;
		if (commandoProductCategories.length > 0) {
			normalizeProductCommandoCategories(commandoProductCategories);
			setCommandoCategories(commandoProductCategories);
		}
	}, [props.commandoProductCategories]);

	//useffect to call functions
	useEffect(() => {
		const { getUCByCityId, getWarehouseByCityId } = props;
		if (props.selectedCity.id) {
			if (dynamicPromoState.dynamicPromoCriteriaType === UC) {
				getUCByCityId(props.selectedCity.id);
			} else if (dynamicPromoState.dynamicPromoCriteriaType === WAREHOUSE) {
				getWarehouseByCityId(props.selectedCity.id);
			}
		}
	}, [dynamicPromoState.dynamicPromoCriteriaType]);

	//useffect to set list -> warehouse/uc
	useEffect(() => {
		// const {isUcFetched, ucList} = props;
		if (dynamicPromoState.isDynamicTypeFetched) {
			if (dynamicPromoState.dynamicPromoCriteriaType === UC_TYPE) {
				setUcList(props.ucList);
				setWarehouseList([]);
			} else if (dynamicPromoState.dynamicPromoCriteriaType === WAREHOUSE) {
				setUcList([]);
				setWarehouseList(props.warehouseList);
			}
		}
	}, [props.ucList, props.warehouseList]);

	useEffect(() => {
		const { isWarehouseFetched, warehouseList } = props;
		if (isWarehouseFetched && warehouseList?.length) {
			setWarehouseList(warehouseList);
		}
	}, [props.isWarehouseFetched, props.warehouseList]);

	const validateForm = props.isEdit
		? true
		: promoType === '0'
		? volumetricPromoState.productId.length > 0 &&
		  volumetricPromoState.customerChannels.length > 0 &&
		  validateSlabs(volumetricPromoState)
		: promoType === '1'
		? validateBasketPromo(basketPromoState)
		: promoType === '2'
		? dynamicPromoState.productId.length > 0 && validateDynamicPromo(dynamicPromoState)
		: validateUserLevelPromo(userLevelPromoState);

	const additionalValidate =
		promoType === '1' && basketPromoState && basketPromoState.basketCategories === '-1';

	const headingText = isEdit ? (promo ? `${promo.promoCode}` : '') : NEW_PROMO;

	const buttonText = isEdit ? UPDATE_A_PROMO : ADD_A_PROMO;

	const notificationModalState = () => {
		setNotificationModal(!notificationModal);
	};

	const closeSearch = () => {
		setIsSearching(false);
		setSearchTerm('');
		setProductData([]);
	};

	const closeModal = () => {
		setProductData([]);
		setIsShowModal(false);
		setIsSearching(false);
		setSearchTerm('');
	};

	const handleGoBackButton = () => {
		const { clearPromoDetails, backButtonHandler } = props;
		clearPromoDetails();
		backButtonHandler(false, volumetricPromoState.selectedCity);
	};

	//debounceSearch -> callback method for search product listing
	const debounceSearch = useCallback(
		_.debounce(
			(value: any) =>
				doProductAPIsearch(
					value,
					setProductData,
					setProductLoading,
					promoType === '0' ? volumetricPromoState.selectedCity.id : dynamicPromoState.selectedCity.id
				),
			1000
		),
		[]
	);

	//For Volumetric
	const calculateSlabDiscounts = (productOriginalPrice: string): IVolumetricPromoSlabs[] => {
		const slabs = volumetricPromoState.slabs.slice();
		return slabs.map(item => {
			return {
				...item,
				discountedUnitPrice:
					Number(item.discountPerUnit) > 0
						? (Number(productOriginalPrice) - Number(item.discountPerUnit)).toString()
						: '-',
			};
		});
	};

	const calculateVolumetricDynamicUserLevelDiscountedPrice = (val: string) => {
		if (promoType === '0') {
			if (
				volumetricPromoState.productActualPrice &&
				Number(volumetricPromoState.productActualPrice) > 0 &&
				val &&
				Number(val) > 0
			) {
				const discountedPrice = Number(volumetricPromoState.productActualPrice) - Number(val);
				return discountedPrice.toString();
			}
		} else if (promoType === '2') {
			if (
				dynamicPromoState.productActualPrice &&
				Number(dynamicPromoState.productActualPrice) > 0 &&
				val &&
				Number(val) > 0
			) {
				const discountedPrice = Number(dynamicPromoState.productActualPrice) - Number(val);
				setDynamicPromoState({
					...dynamicPromoState,
					discountedUnitPrice: discountedPrice,
				});
				return discountedPrice.toString();
			}
		} else if (promoType === '3') {
			if (
				userLevelPromoState.productActualPrice &&
				Number(userLevelPromoState.productActualPrice) > 0 &&
				val &&
				Number(val) > 0
			) {
				const discountedPrice = Number(userLevelPromoState.productActualPrice) - Number(val);
				setUserLevelPromoState({
					...userLevelPromoState,
					discountedUnitPrice: discountedPrice,
				});
				return discountedPrice.toString();
			}
		}
		return '';
	};

	const checkPromoType = (promoType: String, fieldValue: any) => {
		if (promoType === '0') {
			setVolumetricPromoState({
				...volumetricPromoState,
				channel: fieldValue,
			});
		} else if (promoType === '1') {
			setBasketPromoState({
				...basketPromoState,
				channel: fieldValue,
			});
		} else if (promoType === '2') {
			setDynamicPromoState({
				...dynamicPromoState,
				channel: fieldValue,
			});
		} else if (promoType === '3') {
			setUserLevelPromoState({
				...userLevelPromoState,
				channel: fieldValue,
			});
		}
	};

	const handleSelectChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		if (fieldId === CHANNEL) {
			checkPromoType(promoType, fieldValue);
		} else if (fieldId === TYPE_PROMO) {
			checkPromoType(promoType, fieldValue);
			setDynamicPromoState({
				...dynamicPromoState,
				channel: fieldId,
			});
			setPromoType(fieldValue);
		} else if (fieldId === BASKET_CATEGORIES) {
			setBasketPromoState({
				...basketPromoState,
				[fieldId]: fieldValue,
			});
		} else {
			setPromoType(fieldValue);
		}
	};

	// For volumetric when slab field change
	const handleVolumetricSlabFieldChange = (e: any, slabIndex: number) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		const slabState = volumetricPromoState.slabs.slice();
		if (fieldId === IS_AGREEMENT_CHECK) {
			slabState[slabIndex][fieldId] = !slabState[slabIndex][fieldId];
			setVolumetricPromoState({
				...volumetricPromoState,
				slabs: slabState.slice(),
			});
		} else if (fieldId === DISCOUNT_PER_UNIT) {
			slabState[slabIndex][fieldId] = fieldValue;
			slabState[slabIndex].discountedUnitPrice =
				calculateVolumetricDynamicUserLevelDiscountedPrice(fieldValue);
			setVolumetricPromoState({
				...volumetricPromoState,
				slabs: slabState.slice(),
			});
		} else {
			slabState[slabIndex][fieldId] = fieldValue;
			setVolumetricPromoState({
				...volumetricPromoState,
				slabs: slabState.slice(),
			});
		}
	};

	const handleDiscountPriceDynamicChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;

		if (fieldId === DISCOUNT_PER_UNIT) {
			setDynamicPromoState({
				...dynamicPromoState,
				discountPerUnit: fieldValue,
				discountedUnitPrice: calculateVolumetricDynamicUserLevelDiscountedPrice(fieldValue),
			});
		} else if (fieldId === IS_AGREEMENT_CHECK) {
			setDynamicPromoState({
				...dynamicPromoState,
				isAgreementCheck: true,
			});
		}
	};

	const handlePromoDescriptionChange = (e: any) => {
		const fieldValue: string = e.target.value;

		if (promoType === '3') {
			setUserLevelPromoState({
				...userLevelPromoState,
				promoDescription: fieldValue,
			});
		} else if (promoType === '2') {
			setDynamicPromoState({
				...dynamicPromoState,
				promoDescription: fieldValue,
			});
		} else if (promoType === '1') {
			setBasketPromoState({
				...basketPromoState,
				promoDescription: fieldValue,
			});
		} else if (promoType === '0') {
			setVolumetricPromoState({
				...volumetricPromoState,
				promoDescription: fieldValue,
			});
		}
	};

	const handleDiscountPriceUserLevelChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;

		if (fieldId === DISCOUNT_PER_UNIT) {
			setUserLevelPromoState({
				...userLevelPromoState,
				discountPerUnit: fieldValue,
				discountedUnitPrice: calculateVolumetricDynamicUserLevelDiscountedPrice(fieldValue),
			});
		} else if (fieldId === IS_AGREEMENT_CHECK) {
			setUserLevelPromoState({
				...userLevelPromoState,
				isAgreementCheck: true,
			});
		}
	};

	const handleChangeBasket = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		if (fieldId === IS_AGREEMENT_CHECK || fieldId === PROMO_STATUS) {
			setBasketPromoState({
				...basketPromoState,
				[fieldId]: !basketPromoState[fieldId],
			});
		} else {
			setBasketPromoState({
				...basketPromoState,
				[fieldId]: [fieldValue].toString(),
			});
		}
	};

	const handleVolumetricChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		setVolumetricPromoState({
			...volumetricPromoState,
			[fieldId]: fieldId === PROMO_STATUS ? !volumetricPromoState[fieldId] : fieldValue,
		});
	};

	const handleDynamicChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		setDynamicPromoState({
			...dynamicPromoState,
			[fieldId]: fieldId === PROMO_STATUS ? !dynamicPromoState[fieldId] : fieldValue,
		});
	};

	const handleUserLevelChange = (e: any) => {
		const fieldId: string = e.target.id;
		const fieldValue: string = e.target.value;
		setUserLevelPromoState({
			...userLevelPromoState,
			[fieldId]: fieldId === PROMO_STATUS ? !userLevelPromoState[fieldId] : fieldValue,
		});
	};

	const handleProductSearchInputChange = (e: any) => {
		const value = e.target.value;
		setSearchTerm(value);
		if (value.length >= 3) {
			debounceSearch(value);
		}
		if (value.length > 0 && !isSearch) {
			setIsSearching(true);
		}
		if (value.length === 0 && isSearch) {
			setProductData([]);
		}
	};

	const handleRecordSelection = (event: any, id: any) => {
		selectedProducts.current = [];
		selectedProductIndex.current = [];
		if (promoType === '0') {
			setVolumetricPromoState({
				...volumetricPromoState,
				productVariantId: productData[id].variantId,
				productId: productData[id].id,
				productActualPrice: productData[id].productOriginalPrice as any,
				productTitle: productData[id].itemName,
				productSku: productData[id].productSku,
				slabs: calculateSlabDiscounts(productData[id].productOriginalPrice.toString()),
			});
		} else if (promoType === '2') {
			setDynamicPromoState({
				...dynamicPromoState,
				productVariantId: productData[id].variantId,
				productId: productData[id].id,
				productActualPrice: productData[id].productOriginalPrice as any,
				productTitle: productData[id].itemName,
				productSku: productData[id].productSku,
			});
		} else if (promoType === '3') {
			setUserLevelPromoState({
				...userLevelPromoState,
				productVariantId: productData[id].variantId,
				productId: productData[id].id,
				productActualPrice: productData[id].productOriginalPrice as any,
				productTitle: productData[id].itemName,
				productSku: productData[id].productSku,
			});
		}
		selectedProducts.current.push(productData[id]);
		selectedProductIndex.current.push(id);
		setIsShowModal(false);
		setIsSearching(false);
		setSearchTerm('');
		setProductData([]);
	};

	const handlePromoStatusUpdate = () => {
		const { updatePromoStatus, updatePromo, promo } = props;
		if (promoType === '3') {
			const payload: IUpdatePromoPayload = {
				status: userLevelPromoState.promoStatus ? STATUS.ACTIVE : STATUS.INACTIVE,
				meta: generateDynamicPromoUpdateMeta(userLevelPromoState),
			};
			setNotificationModal(!notificationModal);
			updatePromo(promo.id, payload);
		} else {
			setNotificationModal(!notificationModal);
			updatePromoStatus(promo.id);
		}
	};

	const handleSubmit = () => {
		const { createPromo, createBasketLevel } = props;
		//Volumetric / Dynamic
		if (promoType === '0') {
			const validations: IValidationObject = checkPromoValidations(
				selectedProducts.current[0],
				volumetricPromoState
			);
			if (validations.isValidated) {
				const normalizedPayload: ICreatePromoPayload =
					normalizedVolumetricCreatePromoPayload(volumetricPromoState);
				createPromo(volumetricPromoState.selectedCity.id, normalizedPayload);
				return;
			}
			alert(validations.errorMessage.toString().split(',').join('\r\n'));
		} else if (promoType === '2') {
			const ucList = ucNamesNormalizer(dynamicPromoState.includedUcs);
			const warehouseList = ucNamesNormalizer(dynamicPromoState.includedWarehouses);
			const normalizedPayload: ICreatePromoPayload = normalizedDynamicCreatePromoPayload(
				dynamicPromoState,
				ucList,
				warehouseList
			);
			createPromo(dynamicPromoState.selectedCity.id, normalizedPayload);
			return;
		} else if (promoType === '3') {
			setUserLevelPromoState({
				...userLevelPromoState,
				isUserLevelPromoCsvUploaded: true,
			});
			const normalizedPayload: ICreatePromoPayload =
				normalizedUserLevelCreatePromoPayload(userLevelPromoState);

			const { createUploadUserLevelPromoCsv } = props;
			const normalizedUserLevelCsvPayload = normalizeBulkUploadPayload(
				userLevelPromoState.userLevelCsvFile
			);

			createUploadUserLevelPromoCsv(
				userLevelPromoState.selectedCity.id,
				normalizedPayload,
				normalizedUserLevelCsvPayload
			);
			return;
		}
		//Basket Level
		else {
			const categoryName = commandoCategoryState.find(i => i.id === basketPromoState.basketCategories);
			basketPromoState.basketCategories = {
				name: categoryName?.categoryTitle as string,
				categoryId: categoryName?.id as string,
			};
			const normalizedBasketPromo = normalizeCreateBasketPromoPayload(basketPromoState);
			createBasketLevel(volumetricPromoState.selectedCity.id, normalizedBasketPromo);
		}
	};

	const handleUserLevelCSVInputChange = (userLevelCsvFile: any) => {
		if (userLevelCsvFile) {
			setUserLevelPromoState({
				...userLevelPromoState,
				userLevelCsvFile: userLevelCsvFile,
				userLevelCsvFileName: userLevelCsvFile.name,
				isUserLevelPromoCsvUploaded: true,
			});
			setUserLevelCSVFilename(userLevelCsvFile.name);
		}
	};

	const handleUserLevelCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		setUserLevelCSVFilename('');
		userLevelPromoState.userLevelCsvFileName = UPLOAD_CSV;
		setUserLevelPromoState({
			...userLevelPromoState,
			userLevelCsvFileName: '',
			isUserLevelPromoCsvUploaded: false,
		});
	};

	const handleUserLevel = () => {
		setIsShowUserLevelModal(true);
	};

	const checkAndDisplayButton = () => {
		const { promo } = props;
		return promo && promo.promoStatus ? (promo.promoStatus === ACTIVE ? true : false) : true;
	};

	const renderSearchProductModalBody = () => {
		const buttonText =
			selectedProducts.current.length > 0
				? `Excluded Products (${selectedProducts.current.length} items selected)`
				: `Exclude Products`;
		return (
			<>
				<InputGroup>
					<InputGroupAddon addonType='prepend'>
						<InputGroupText>
							<img src={searchIcon} alt='search' />
						</InputGroupText>
					</InputGroupAddon>
					<Input
						className='search-input'
						placeholder='Search by product name'
						onChange={handleProductSearchInputChange}
						value={searchTerm}
						autoFocus={true}
					/>
					<div className={isSearch ? 'close-button' : 'hide close-button'} onClick={closeSearch}>
						<img src={close} alt='close' />
					</div>
				</InputGroup>
				<section className='product-list-container'>
					{productData.length > 0 && (
						<DataTablePromoProductSearch
							tableId={promoType !== '1' ? 'promo-product-list' : 'promo-basket-promo-list'}
							tableHeaderData={null}
							tableFooterData={promoProductFooterData}
							tableBodyDataTypes={
								promoType !== '1' ? promoProductBodyDataAndKeyTypes : promoBasketProductBodyDataAndKeyTypes
							}
							tableBodyRowData={productData}
							noSearchResultFlag={isSearch}
							editRowHandler={handleRecordSelection}
						/>
					)}
					{isProductLoading && (
						<div>
							<Spinner color='primary' className='spinner' />
						</div>
					)}
				</section>
				{promoType === '1' && (
					<div className='update-order-container'>
						<ButtonComponent
							buttonClass='large-button btn-primary'
							buttonText={buttonText}
							// onClickHandler={updateExcludedProductList}
						/>
					</div>
				)}
				{promoType === '2' && (
					<div className='update-order-container'>
						<ButtonComponent
							buttonClass='large-button btn-primary'
							buttonText={buttonText}
							// onClickHandler={updateExcludedProductList}
						/>
					</div>
				)}
				{promoType === '3' && (
					<div className='update-order-container'>
						<ButtonComponent
							buttonClass='large-button btn-primary'
							buttonText={buttonText}
							// onClickHandler={updateExcludedProductList}
						/>
					</div>
				)}
			</>
		);
	};

	const renderProductList = () => {
		return (
			<Modal
				showModal={showModal}
				modalHeading='Product search'
				closeModalHandler={closeModal}
				showProgressString={false}
				failedRecords=''
				modalBodyClass='product-search'
			>
				{renderSearchProductModalBody()}
			</Modal>
		);
	};

	const renderVolumetricDetail = () => {
		return (
			<>
				<section className='search-container'>
					{!props.isEdit ? (
						<InputGroup>
							<InputGroupAddon addonType='prepend'>
								<InputGroupText>
									<img src={searchIcon} alt='search' />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								className='search-input'
								placeholder='Search by product name'
								onFocus={() => setIsShowModal(true)}
							/>
						</InputGroup>
					) : (
						<TextField
							id='productTitle'
							label='Product'
							placeholder='-'
							value={volumetricPromoState.productTitle}
							disabled
						/>
					)}
				</section>
				<TextField
					id='actualPrice'
					label='Actual Price'
					placeholder='-'
					value={volumetricPromoState.productActualPrice}
					disabled
				/>
			</>
		);
	};

	const renderBasketDetail = () => {
		return (
			<>
				<SelectDropDown
					label='Category'
					options={commandoCategoryState}
					id='basketCategories'
					handleChange={handleSelectChange}
					value={basketPromoState.basketCategories}
					defaultOption={{
						id: '-1',
						value: '',
						text: 'Select a category',
					}}
					disabled={props.isEdit}
				/>
			</>
		);
	};

	const renderDynamicDetail = () => {
		return (
			<>
				<section className='search-container'>
					{!props.isEdit ? (
						<InputGroup>
							<InputGroupAddon addonType='prepend'>
								<InputGroupText>
									<img src={searchIcon} alt='search' />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								className='search-input'
								placeholder='Search by product name'
								onFocus={() => setIsShowModal(true)}
							/>
						</InputGroup>
					) : (
						<TextField
							id='productTitle'
							label='Product'
							placeholder='-'
							value={dynamicPromoState.productTitle}
							disabled
						/>
					)}
				</section>
				<TextField
					id='actualPrice'
					label='Actual Price'
					placeholder='-'
					value={dynamicPromoState.productActualPrice}
					disabled
				/>
			</>
		);
	};

	const renderUserLevelDetail = () => {
		return (
			<>
				<section className='search-container'>
					{!props.isEdit ? (
						<InputGroup>
							<InputGroupAddon addonType='prepend'>
								<InputGroupText>
									<img src={searchIcon} alt='search' />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								className='search-input'
								placeholder='Search by product name'
								onFocus={() => setIsShowModal(true)}
							/>
						</InputGroup>
					) : (
						<TextField
							id='productTitle'
							label='Product'
							placeholder='-'
							value={userLevelPromoState.productTitle}
							disabled
						/>
					)}
				</section>
				<TextField
					id='actualPrice'
					label='Actual Price'
					placeholder='-'
					value={userLevelPromoState.productActualPrice}
					disabled
				/>
			</>
		);
	};

	const renderPromoType = () => {
		if (promoType === '0') {
			renderVolumetricDetail();
		} else if (promoType === '2') {
			renderDynamicDetail();
		} else if (promoType === '3') {
			renderUserLevelDetail();
		} else if (promoType === '4') {
			renderBasketDetail();
		}
	};

	const renderPromoDetail = () => {
		const isKarachi = volumetricPromoState.selectedCity.name === 'Karachi';
		const promoOptions = isKarachi ? PROMO_OPTIONS.slice(1) : PROMO_OPTIONS;
		return (
			<FormSectionLayout subTitleText='Promo details'>
				<div className='form-row'>
					<Col>
						<TextField
							id='selectedCity'
							label='City'
							placeholder='e.g. Karachi'
							value={volumetricPromoState.selectedCity.name}
							handleChange={() => {}}
							disabled={true}
						/>
					</Col>
				</div>
				<div className='form-row'>
					<Col>
						<SelectDropDown
							label='Type'
							options={promoOptions}
							id='promoType'
							handleChange={handleSelectChange}
							value={promoType}
							defaultOption={{
								id: '-1',
								value: 'Select promo type',
								text: 'Select promo type',
							}}
							disabled={props.isEdit}
						/>
					</Col>
				</div>
				<SelectDropDown
					label='Channel'
					options={
						promoType === '0'
							? CHANNEL_OPTIONS[0]
							: promoType === '1'
							? CHANNEL_OPTIONS[1]
							: promoType === '2'
							? CHANNEL_OPTIONS[2]
							: promoType === '3'
							? CHANNEL_OPTIONS[3]
							: CHANNEL_OPTIONS[0]
					}
					id='channel'
					handleChange={handleSelectChange}
					value={
						promoType === '1'
							? basketPromoState.channel
							: promoType === '0'
							? volumetricPromoState.channel
							: CHANNEL_CUSTOMER_APP
					}
					defaultOption={{
						id: '-1',
						value: 'Select Channel',
						text: 'Select Channel',
					}}
					disabled={props.isEdit || promoType === '2' || promoType === '3'}
				/>
				<div className='form-row'>
					<Col>
						<MultiSelectDropDown
							options={
								props.customerConfig && (promoType === '0' || promoType === '2')
									? props.customerConfig.customerChannels
									: []
							}
							label='Customer Channels'
							placeholder='Please select Customer Channels'
							displayValue='title'
							selectedValues={
								isEdit
									? props.promoDetails.customerChannels
									: promoType === '0' || promoType === '2'
									? []
									: props.customerConfig.customerChannels
							}
							onChange={handleCustomerChannelChange}
							onRemove={handleCustomerChannelChange}
							className='customerChannelOptions'
							isDisable={isEdit || (promoType !== '0' && promoType !== '2')}
						/>
					</Col>
				</div>
				<TextField
					id='promoDescription'
					label='Promo Description'
					placeholder='Promo Description'
					value={
						isEdit
							? props.promoDetails.promoDescription
							: promoType === '0'
							? volumetricPromoState.promoDescription
							: promoType === '1'
							? basketPromoState.promoDescription
							: promoType === '2'
							? dynamicPromoState.promoDescription
							: promoType === '3'
							? userLevelPromoState.promoDescription
							: ''
					}
					handleChange={handlePromoDescriptionChange}
					// error={decimalOnlyValidator(dynamicPromoState.discountPerUnit)}
					disabled={props.isEdit}
				/>
				{promoType === '0'
					? renderVolumetricDetail()
					: promoType === '2'
					? renderDynamicDetail()
					: promoType === '3'
					? renderUserLevelDetail()
					: renderBasketDetail()}
				<Switch
					id='promoStatus'
					label='Status'
					checked={
						promoType === '0'
							? volumetricPromoState.promoStatus
							: promoType === '1'
							? basketPromoState.promoStatus
							: promoType === '2'
							? dynamicPromoState.promoStatus
							: userLevelPromoState.promoStatus
					}
					handleSwitch={
						promoType === '0'
							? handleVolumetricChange
							: promoType === '1'
							? handleChangeBasket
							: promoType === '2'
							? handleDynamicChange
							: handleUserLevelChange
					}
					statusVal1={ACTIVE}
					statusVal2={INACTIVE}
					disabled={!props.isEdit}
				/>
			</FormSectionLayout>
		);
	};

	const renderBasketPromoCriteria = () => {
		return (
			<>
				<TextField
					id='minOrderValue'
					label='Minimum order value'
					placeholder='e.g. Rs. 10'
					value={basketPromoState.minOrderValue}
					handleChange={handleChangeBasket}
					error={decimalOnlyValidator(basketPromoState.minOrderValue)}
					disabled={props.isEdit}
				/>
				<div className='form-row'>
					<Col sm='2'>
						<SelectDropDown
							label='Discount'
							options={PROMO_BASKET_DISCOUNT_OPTIONS}
							id='discountType'
							handleChange={handleSelectChange}
							value={basketPromoState.discountType}
							defaultOption={{
								id: '-1',
								value: '',
								text: 'Unit',
							}}
							disabled
						/>
					</Col>
					<Col sm='10'>
						<div className='product-weight-unit'>
							<TextField
								id='discountValue'
								label=''
								placeholder='e.g. 15'
								value={basketPromoState.discountValue}
								handleChange={handleChangeBasket}
								error={decimalOnlyValidator(basketPromoState.discountValue)}
								disabled={props.isEdit}
							/>
						</div>
					</Col>
				</div>
			</>
		);
	};

	function renderDynamicDiscountPrice() {
		return (
			<>
				<TextField
					id='discountPerUnit'
					label='Discount per unit'
					placeholder='e.g. 20'
					value={
						!isEdit ? dynamicPromoState.discountPerUnit : props.promoDetails.discountPerUnit.discount
					}
					handleChange={(e: any) => handleDiscountPriceDynamicChange(e)}
					error={decimalOnlyValidator(dynamicPromoState.discountPerUnit)}
					disabled={props.isEdit}
				/>
				<TextField
					id='discountedUnitPrice'
					label='Discounted Unit Price'
					placeholder='-'
					value={dynamicPromoState.discountedUnitPrice}
					disabled
				/>
			</>
		);
	}

	const renderUserLevelDiscountPrice = () => {
		return (
			<>
				<TextField
					id='discountPerUnit'
					label='Discount per unit'
					placeholder='e.g. 20'
					value={userLevelPromoState.discountPerUnit}
					handleChange={handleDiscountPriceUserLevelChange}
					// error={decimalOnlyValidator(userLevelPromoState.discountPerUnit)}
					disabled={!checkAndDisplayButton()}
				/>
				<TextField
					id='discountedUnitPrice'
					label='Discounted Unit Price'
					placeholder='-'
					value={userLevelPromoState.discountedUnitPrice}
					disabled
				/>
			</>
		);
	};

	const renderDynamic = () => {
		if (!isEdit) {
			if (dynamicPromoState.dynamicPromoCriteriaType === UC) {
				return (
					<MultiSelectDropDown
						options={ucs}
						label='Select UC'
						selectedValues={dynamicPromoState.includedUcs}
						placeholder='Please select UC'
						displayValue='label'
						onChange={handleUCDynamicPromoChange}
						onRemove={handleUCDynamicPromoChange}
					/>
				);
			} else if (dynamicPromoState.dynamicPromoCriteriaType === WAREHOUSE) {
				return (
					<MultiSelectDropDown
						options={warehouses}
						label='Select Warehouse'
						selectedValues={dynamicPromoState.includedWarehouses}
						placeholder='Please select Warehouse'
						displayValue='label'
						onChange={handleWarehouseDynamicPromoChange}
						onRemove={handleWarehouseDynamicPromoChange}
					/>
				);
			}
		} else {
			if (props.promoDetails.promoMeta.includedUcs?.length > 0) {
				return (
					<MultiSelectDropDown
						options={ucs}
						label='Selected UC'
						// selectedValues={dynamicPromoState.includedUcs}
						placeholder={props.promoDetails.promoMeta.includedUcs.join(', ')}
						displayValue='label'
						onChange={handleUCDynamicPromoChange}
						onRemove={handleUCDynamicPromoChange}
						isDisable={isEdit}
					/>
				);
			} else if (props.promoDetails.promoMeta.includedWarehouses?.length > 0) {
				return (
					<MultiSelectDropDown
						options={warehouses}
						label='Selected Warehouse'
						// selectedValues={dynamicPromoState.includedWarehouses}
						placeholder={props.promoDetails.promoMeta.includedWarehouses.join(', ')}
						displayValue='label'
						onChange={handleWarehouseDynamicPromoChange}
						onRemove={handleWarehouseDynamicPromoChange}
						isDisable={isEdit}
					/>
				);
			}
		}
	};

	const handleCustomerChannelChange = (e: Array<ISelectDropdownOption>) => {
		switch (promoType) {
			case PROMO_TYPE_CONST.VOLUMETRIC:
				setVolumetricPromoState({
					...volumetricPromoState,
					customerChannels: e,
				});
				break;

			case PROMO_TYPE_CONST.BASKET:
				setBasketPromoState({
					...basketPromoState,
					customerChannels: e,
				});
				break;

			case PROMO_TYPE_CONST.DYNAMIC:
				setDynamicPromoState({
					...dynamicPromoState,
					customerChannels: e,
				});
				break;

			case PROMO_TYPE_CONST.ULP:
				setUserLevelPromoState({
					...userLevelPromoState,
					customerChannels: e,
				});
				break;
		}
	};

	const handleDynamicLevelSelect = (e: IIdValuePairResponse, fieldId: string) => {
		setDynamicPromoState({
			...dynamicPromoState,
			dynamicPromoCriteriaType: e.value,
		});
	};

	const handleUCDynamicPromoChange = (e: any) => {
		const ucs = dynamicPromoState;
		ucs.includedUcs = e.slice();
		setDynamicPromoState({
			...ucs,
		});
	};

	const handleWarehouseDynamicPromoChange = (e: any) => {
		const warehouses = dynamicPromoState;
		warehouses.includedWarehouses = e.slice();
		setDynamicPromoState({
			...warehouses,
		});
	};

	const ucNamesNormalizer = (ucs: any) => {
		let ucFinalList: any = [];
		ucs.forEach((ucName: any) => {
			ucFinalList.push(ucName.id);
		});
		return ucFinalList;
	};

	const handleChannelChange = (e: any) => {
		alert('Channel change called');
		// const clients = accessControlState;
		// clients.clients = e.slice();
		// setAccessControlState({
		//   ...clients,
		// });
	};

	const renderUserLevelPromoCriteria = () => {
		return (
			<>
				{renderUserLevelDiscountPrice()}

				{renderUserLevelCSV()}
				{showUserLevelModal ? renderError() : ''}
			</>
		);
	};

	const renderUserLevelCSV = () => {
		if (!isEdit) {
			return (
				<div className='user-level-upload-component-container-wrapper spacing-wireframe'>
					<div className='pt-3 pb-1'></div>
					<Row>
						<Col lg='6'>
							<UploadButtonComponent
								id='upload-user-level-csv'
								buttonText={userLevelCsvFileName ? userLevelCsvFileName : 'Upload .CSV '}
								fileFormat={acceptableFormats.csv}
								fileUploaded={!!userLevelCsvFileName}
								handleRemoveFile={handleUserLevelCSVRemove}
								handleFileChange={handleUserLevelCSVInputChange}
								classes='large-button btn-primary'
							/>
						</Col>
					</Row>
					{
						// userLevelPromoState.userLevelCsvFileName !== "" ||
						// props.isUserLevelPromoCsvUploaded
						!userLevelPromoState.isUserLevelPromoCsvUploaded ||
						(userLevelPromoState.isUserLevelPromoCsvUploaded &&
							!userLevelPromoState.isUserLevelPromoCsvError) ? (
							<div className='btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center'>
								<span>max 3,000 lines</span>
								<a href={require('../../../assets/static/promo.csv')} target='_blank' className=''>
									<small>Download Sample </small>
								</a>
							</div>
						) : userLevelPromoState.isUserLevelPromoCsvUploaded &&
						  !userLevelPromoState.isUserLevelPromoCsvError ? (
							<div className='btn-primary-outline button-large btn btn-secondary no-border-btn'>
								<span>
									<img src={uploadSvg} alt='close' />
									Uploading ...
								</span>
							</div>
						) : userLevelPromoState.isUserLevelPromoCsvUploaded &&
						  userLevelPromoState.isUserLevelPromoCsvError ? (
							<div
								className='btn-primary-outline button-large btn btn-secondary no-border-btn'
								onClick={handleUserLevel}
							>
								<span className='textWarning d-flex align-items-center justify-content-center hyperlink'>
									<img src={error} alt='close' />
									Error! Could not upload. Try again.
								</span>
							</div>
						) : (
							<div className='btn-primary-outline button-large btn btn-secondary no-border-btn'>
								<span className='d-flex align-items-center justify-content-center hyperlink'>
									<svg
										className='mr-1 mt-1'
										width='12'
										height='10'
										viewBox='0 0 13 14'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path
											d='M11 1L3.69484 9L1 6.18825'
											stroke='#009F23'
											stroke-linecap='round'
											stroke-linejoin='round'
										/>
									</svg>
									Successfully uploaded!
								</span>
							</div>
						)
					}
				</div>
			);
		}
	};

	const renderError = () => {
		if (
			props.isUserLevelPromoCsvError &&
			userLevelPromoState.isUserLevelPromoCsvUploaded &&
			showUserLevelModal
		) {
			return (
				<Modal
					modalHeading='User Level CSV'
					showModal={showUserLevelModal}
					closeModalHandler={() => closeUserLevelModal(setIsShowUserLevelModal, showUserLevelModal)}
					isSuccess={props.isUserLevelPromoCsvUploaded && !props.isUserLevelPromoCsvError ? true : false}
					failedRecords={props.isUserLevelPromoCsvError ? '' : ''}
					modalBodyClass='batch-modal'
					showProgressString={false}
				>
					{props.isUserLevelPromoCsvError ? (
						<div className='py-3'>
							<section className='upload-error'>
								<img src={warning} />
								<div className='title'>Upload failed</div>
							</section>

							{props.isUserLevelPromoCsvError && (
								<div className='desc'>
									{props.isUserLevelPromoCsvError &&
										(props.isUserLevelPromoCsvError! as any).errors.map((e: String[]) => {
											return <div className='format-msg-style'>{e}</div>;
										})}
								</div>
							)}
						</div>
					) : null}
				</Modal>
			);
		}
	};

	const renderDynamicPromoCriteria = () => {
		return (
			<>
				<SearchableSelect
					id='dynamicPromoCriteriaType'
					isSearchable={true}
					options={ULP_DYNAMIC_LEVEL}
					onChange={(e: any) => {
						handleDynamicLevelSelect(e, DYNAMIC_PROMO_CRITERIA_TYPE);
					}}
					label='Level'
					placeholder={
						!isEdit
							? 'Select Level'
							: props.promoDetails.promoMeta.includedUcs?.length > 0
							? 'UC'
							: props.promoDetails.promoMeta.includedWarehouses.length > 0
							? 'Warehouse'
							: ''
					}
					selectedValue={
						!isEdit
							? props.dynamicPromoCriteriaType
							: props.promoDetails.promoMeta.includedUcs?.length > 0
							? 'UC'
							: props.promoDetails.promoMeta.includedWarehouses.length > 0
							? 'Warehouse'
							: ''
					}
					isDisabled={isEdit}
				/>
				{renderDynamic()}
				{renderDynamicDiscountPrice()}
			</>
		);
	};

	const renderVolumetricPromoCriteriaSlabs = (slab: number) => {
		return (
			<>
				<TextField
					id='minUnits'
					label='Min Units'
					placeholder='e.g. 10'
					value={volumetricPromoState.slabs[slab].minUnits}
					handleChange={(e: any) => handleVolumetricSlabFieldChange(e, slab)}
					error={positiveNegativeNumberValidator(volumetricPromoState.slabs[slab].minUnits)}
					disabled={props.isEdit}
				/>
				<TextField
					id='discountPerUnit'
					label='Discount per unit'
					placeholder='e.g. 20'
					value={volumetricPromoState.slabs[slab].discountPerUnit}
					handleChange={(e: any) => handleVolumetricSlabFieldChange(e, slab)}
					error={decimalOnlyValidator(volumetricPromoState.slabs[slab].discountPerUnit)}
					disabled={props.isEdit}
				/>
				<TextField
					id='discountedUnitPrice'
					label='Discounted Unit Price'
					placeholder='-'
					value={volumetricPromoState.slabs[slab].discountedUnitPrice}
					disabled
				/>
			</>
		);
	};

	const renderPromoSummary = () => {
		return (
			<FormSectionLayout subTitleText='Summary'>
				{promoType === '0'
					? renderVolumetricSummaryAndAgreementChecks()
					: promoType === '1'
					? renderBasketSummaryAndAgreementCheck()
					: promoType === '2'
					? renderDynamicSummaryAndAgreementChecks()
					: renderUserLevelSummaryAndAgreementChecks()}
				<div>{renderFormButton()}</div>
			</FormSectionLayout>
		);
	};

	const renderBasketSummaryAndAgreementCheck = () => {
		return (
			<Checkbox
				id='isAgreementCheck'
				label={renderPromoSummaryText(0) as JSX.Element}
				handleCheckboxChange={handleChangeBasket}
				isChecked={basketPromoState.isAgreementCheck}
				disabled={props.isEdit}
			/>
		);
	};

	const renderVolumetricSummaryAndAgreementChecks = () => {
		return volumetricPromoState.slabs.map((item: IVolumetricPromoSlabs, index: number) => {
			return (
				(index !== 1 || (item.minUnits && item.discountPerUnit)) && (
					<Checkbox
						id='isAgreementCheck'
						label={renderPromoSummaryText(index) as JSX.Element}
						handleCheckboxChange={(e: any) => handleVolumetricSlabFieldChange(e, index)}
						isChecked={volumetricPromoState.slabs[index].isAgreementCheck}
						disabled={props.isEdit}
					/>
				)
			);
		});
	};

	const renderDynamicSummaryAndAgreementChecks = () => {
		return (
			<Checkbox
				id='isAgreementCheck'
				label={renderPromoSummaryText(0) as JSX.Element}
				handleCheckboxChange={(e: any) => handleDiscountPriceDynamicChange(e)}
				isChecked={dynamicPromoState.isAgreementCheck}
				disabled={props.isEdit}
			/>
		);
	};

	const renderUserLevelSummaryAndAgreementChecks = () => {
		return (
			<Checkbox
				id='isAgreementCheck'
				label={renderPromoSummaryText(0) as JSX.Element}
				handleCheckboxChange={handleDiscountPriceUserLevelChange}
				isChecked={userLevelPromoState.isAgreementCheck}
				disabled={props.isEdit}
			/>
		);
	};

	const renderPromoSummaryText = (index: number) => {
		return promoType === '0' ? (
			<p className='summary-text'>
				Volumetric Promo <b>Rs. {volumetricPromoState.slabs[index].discountPerUnit}</b> discount per
				unit if they order more than <b>{volumetricPromoState.slabs[index].minUnits}</b> units for{' '}
				<b>{volumetricPromoState.productTitle}</b>
			</p>
		) : promoType === '1' ? (
			<p className='summary-text'>
				Users will get a <b>Rs. {basketPromoState.discountValue}</b> discount on ordering products worth{' '}
				<b>Rs. {basketPromoState.minOrderValue}</b>
			</p>
		) : promoType === '2' ? (
			<p className='summary-text'>
				<b>{dynamicPromoState.productTitle}</b> will have a discount of{' '}
				<b>
					Rs.
					{!isEdit ? dynamicPromoState.discountPerUnit : props.promoDetails.discountPerUnit.discount}
				</b>{' '}
				per unit for{' '}
				<b>
					{!isEdit
						? dynamicPromoState.dynamicPromoCriteriaType
						: props.promoDetails.promoMeta.includedUcs?.length > 0
						? props.promoDetails.promoMeta.includedUcs.join(', ')
						: props.promoDetails.promoMeta.includedWarehouses.length > 0
						? props.promoDetails.promoMeta.includedWarehouses.join(', ')
						: ''}
				</b>
			</p>
		) : (
			<p className='summary-text'>
				<b>{userLevelPromoState.productTitle}</b> will have a discount of{' '}
				<b>
					Rs.
					{userLevelPromoState.discountPerUnit}{' '}
				</b>{' '}
				for uploaded cohort
			</p>
		);
	};

	const renderFormButton = () => {
		return (
			<div className='form-row-separator'>
				<Row id='addEditButtonRow' className='add-update-button-container'>
					<Col lg='6'>
						{checkAndDisplayButton() &&
							(ability.can('update', 'promo') || ability.can('create', 'promo')) && (
								<ButtonComponent
									buttonClass='large-button btn-primary'
									buttonText={buttonText}
									onClickHandler={props.isEdit ? notificationModalState : handleSubmit}
									isDisable={props.isLoading || !validateForm || additionalValidate}
								/>
							)}
					</Col>
				</Row>
			</div>
		);
	};

	const renderNotificationModal = () => {
		return (
			<div id='confirmationModal'>
				<p>Are you sure you want to update this promo?</p>
				<Row
					className='button-container'
					style={{
						flexWrap: 'nowrap',
					}}
				>
					<Col lg='6'>
						<ButtonComponent
							buttonClass='button-small btn btn-primary-outline'
							buttonText='Go back'
							onClickHandler={notificationModalState}
						/>
					</Col>
					<Col lg='6'>
						<ButtonComponent
							buttonClass='button-small btn btn-primary verify-btn'
							buttonText='Update'
							onClickHandler={handlePromoStatusUpdate}
						/>
					</Col>
				</Row>
			</div>
		);
	};

	//main control of return UI
	return (
		<Container fluid>
			{(props.isLoading || props.isFetchCategoryLoading) && <LoaderComponent />}
			<Modal
				showModal={notificationModal}
				closeModalHandler={notificationModalState}
				modalHeading='Are you sure?'
				showProgressString={false}
				failedRecords=''
				modalBodyClass='notification-account'
			>
				{renderNotificationModal()}
			</Modal>
			<Row>
				<Col lg='5'>
					<div className='back-button'>
						<a href='javascript:void(0)' onClick={handleGoBackButton}>
							{' '}
							{/* TO-DO: Convert this to a button in all compoents. */}
							<span>
								<img src={backArrow} alt='close' />
							</span>{' '}
							Back to Promos
						</a>
					</div>
					<HeadingText text={headingText} isMainHeading={true} />
				</Col>
				<Col lg='5'>
					{props.isEdit && props.promoDetails && (
						<section className='promo-status-container'>
							<section className='order-status-detail'>
								<div className='status-detail'>
									Created at <span>{props.promoDetails.createdAt}</span> by <span>{createdByUser}</span>
								</div>
							</section>
							{props.promoDetails.createdAt !== props.promoDetails.updatedAt && (
								<section className='order-updated'>
									Last updated at <span>{props.promoDetails.updatedAt}</span> by <span>{updatedByUser}</span>
								</section>
							)}
						</section>
					)}
				</Col>
			</Row>
			<Row className='form-container'>
				<Col xs='12'>
					<Form>
						<div className='promos-detail'>{renderPromoDetail()}</div>
						<div className='promo-criteria form-row-separator'>
							<FormSectionLayout subTitleText='Criteria'>
								{promoType === '0' ? (
									<Tabs
										tabsData={[
											{
												id: '1',
												tabLink: 'SLAB 1',
												content: renderVolumetricPromoCriteriaSlabs(0),
											},
											{
												id: '2',
												tabLink: 'SLAB 2',
												content: renderVolumetricPromoCriteriaSlabs(1),
											},
										]}
									/>
								) : promoType === '1' ? (
									renderBasketPromoCriteria()
								) : promoType === '2' ? (
									renderDynamicPromoCriteria()
								) : (
									renderUserLevelPromoCriteria()
								)}
							</FormSectionLayout>
						</div>
						<div className='summary-detail form-row-separator'>
							{renderPromoSummary()}
							{renderProductList()}
						</div>
					</Form>
				</Col>
			</Row>
		</Container>
	);
};

export default AddUpdatePromosPage;
